export default "__VITE_ASSET__99a4bd96__"